var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.$diff)?_c('pre',{domProps:{"innerHTML":_vm._s(_vm.diffText)}}):_c('div',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.model.$value))])
}
var staticRenderFns = []

export { render, staticRenderFns }